module.exports = __webpack_public_path__ + "static/media/gain_might.95cdddd0.png";